import $ from 'jquery';
import Glide from '@glidejs/glide';

// only do this if class exists
if ( $ ( ".slide" ).length ) {
  
  // check if class is in viewport
  $( window ).scroll( function() {
    var top_of_element = $( ".slide" ).offset().top;
    var bottom_of_element = $( ".slide" ).offset().top + $( ".slide" ).outerHeight();
    var bottom_of_screen = $( window ).scrollTop() + $( window ).innerHeight();
    var top_of_screen = $( window ).scrollTop();
  
    if ( ( bottom_of_screen > top_of_element ) && ( top_of_screen < bottom_of_element ) ) {
        // if .slide is visible, hand it the class .slide-me
        $( ".slide" ).addClass( "slide-me" );
    };
  });
};

// Testimony Slider
if ( $( '.testimony-section' ).length ) {
  var glide = document.querySelectorAll('.glide')

  glide.forEach( ( elem ) => {
    new Glide( elem, {
      type: 'slider',
      autoplay: 7000,
      hoverpause: true,
    }).mount()
  } )
}

// Contact Form
if( $( '.contact-form-section' ).length ) {
  $( '.wpcf7-form' ).on( 'submit', (e) => {
    e.preventDefault()

    $( '.form-container' )
      .animate( { opacity: 0 }, 400, function() {
        $( '.wpcf7-form' ).hide();
        $( '.form-text-container' ).show();
      })
      .animate( { opacity: 1 }, 400 );
    
    dataLayer.push( { 'event': 'register_complete', 'value': 'form_submit' } );
  } )
}

// mailto base64 conversion
// if( $( '[href^="mailto:"]' ).length ){
//   $( '[href^="mailto:"]' ).each( function() {
//     let $this = $( this )
//     let mail = $this.attr( 'href' ).match( '^mailto:(.*)\=$' )
//     console.log( 'string to convert ' + mail[1] )

//     // let data = decodeURIComponent( mail[1] )
//     // console.log( 'decoded string ' + data )

//     let mailto = atob( mail[1] )
//     console.log( mailto )

//     // $this.attr( 'href', 'mailto:' + mailto )

//   })
// }